export var shadow = 'NaBNH';